import { observable, computed, flow } from 'mobx';

import api from '../services/api';

class Core {
    constructor() {
        this.fetch();
    }
    
    @observable
    _content = [];

    @computed
    get content() {
        return this._decorateContent(this._content);
    }
    
    fetch = flow(function*() {
        try {
            this._content = yield api.Core.content();
        } catch (e) {
            this.error = e.message;
        } finally {
            this.loading = false;
        }
    });

    _decorateContent(content) {
        return content;
    }
}

export default new Core();
